













































import { computed, ref, watch } from '@vue/composition-api';
import { deepClone, getDoctorInfo, asyncThrottle } from '@/utils/utils';
import { apiGetCustomTagGroupList } from '@/services/user';
import { DoctorInfo } from '@/types/type';
import { CustomLabelItem, MarkLabelItem } from '@/common-page/patient-detail/type/type';
export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: Boolean,
    patientId: {
      type: String,
      default: '',
    },
    patientTags: {
      type: Object,
      default: () => {},
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit, root }: any) {
    const computedShow = computed({
      get() {
        return props.show;
      },
      set() {
        closeDialog();
      },
    });

    const closeDialog = () => {
      emit('change', false);
    };

    const keyword = ref('');

    const doctorInfo = ref<any | DoctorInfo>({});

    const markLabelList = ref<MarkLabelItem[]>([]);

    const query = ref({ currentPage: 0, pageSize: 10 });
    const customLabelList = ref<CustomLabelItem[]>([]);
    const getCustomTagGroupList = async () => {
      const { data = [] }: any = await apiGetCustomTagGroupList({ ...query.value, key: keyword.value });
      console.log(query.value.currentPage, query.value.currentPage === 0);

      if (query.value.currentPage === 0) {
        customLabelList.value = data;
      } else {
        customLabelList.value = [...customLabelList.value, ...data];
      }
    };

    const onKeywordSearch = async () => {
      if (!keyword.value) patientTagList.value = patientTagListByAll.value;

      patientTagList.value = deepClone(patientTagListByAll.value)
        .map((group) => {
          group.tagValues = group.tagValues.filter(tagValuesItem => tagValuesItem.includes(keyword.value));
          return group;
        })
        .filter(group => group.tagValues.length);
      console.log(patientTagListByAll.value, 'patientTagListByAll.value');

      console.log(patientTagList.value, 'patientTagList.value');
    };
    const highlightMatch = (text) => {
      if (!keyword.value) return text;
      const regex = new RegExp(`(${keyword.value})`, 'i');
      return text.replace(regex, `<span style="color: #F79B31;">${keyword.value}</span>`);
    };

    const group = {
      baseInfo: '基本信息',
      diseaseInfo: '疾病信息',
      healthHistory: '健康史',
      healthIndicators: '健康指标',
      lifestyle: '生活方式',
    };

    const patientTagListByAll = ref<any[]>([]);
    const patientTagList = ref<any[]>([]);

    const init = async () => {
      doctorInfo.value = await getDoctorInfo();
      console.log(props.patientTags, '000');
      patientTagListByAll.value = Object.keys(props.patientTags).map(key => ({
        tagGroupId: key,
        tagGroupName: group[key],
        tagValues: props.patientTags[key],
      }));
      patientTagList.value = patientTagListByAll.value.filter(item => item.tagValues.length);
    };
    const onTagClick = (tag) => {
      if (selectedTagList.value.includes(tag)) {
        selectedTagList.value = selectedTagList.value.filter(item => item !== tag);
      } else {
        selectedTagList.value.push(tag);
      }
    };
    const selectedTagList = ref<any[]>([]);

    watch(
      () => props.show,
      (val) => {
        if (val) {
          query.value.currentPage = 0;
          keyword.value = '';
          init();
          selectedTagList.value = JSON.parse(JSON.stringify(props.selectedList));
        }
      },
      {
        immediate: true,
      },
    );

    const markLabel = (item: CustomLabelItem, labelValue: string) => {
      const { tagGroupId, tagGroup, tagTypeName } = item;
      const target = markLabelList.value.find(markLabelItem => markLabelItem.tagGroupId === tagGroupId);
      if (target) {
        const labelValueIndex = target?.tagValues?.indexOf(labelValue);
        if (labelValueIndex !== -1) {
          target.tagValues.splice(labelValueIndex, 1);
        } else {
          if (!target.tagValues) target.tagValues = [];
          target.tagValues.push(labelValue);
        }
      } else {
        markLabelList.value.push({
          tagTypeName,
          tagGroupId,
          tagGroup,
          tagValues: [labelValue],
        });
      }
    };

    const isMark = (tagGroupId: number, labelValue: string) => {
      const target = markLabelList.value.find(markLabelItem => markLabelItem.tagGroupId === tagGroupId);
      if (target) {
        return target?.tagValues?.includes(labelValue);
      }
      return false;
    };

    const goTagManage = () => {
      root.$router.push({
        path: '/default/tagManage',
        query: {
          timeStamp: new Date().getTime(),
          currentTTab: 'customLabel',
        },
      });
    };

    const confirm = async () => {
      emit('confirm', selectedTagList.value);
      computedShow.value = false;
      // 如果医生对标签进行了重新勾选，需要把数据存到localStorage中,以便下次回显
      // {doctorInfo.userId:{patientId:[patientTags]}}
      // 获取现有的 localStorage 数据
      const localStorageData = JSON.parse(localStorage.getItem('patientTags') || '{}');

      // 获取当前医生的患者标签数据，如果不存在则初始化为空对象
      const doctorPatientTags = localStorageData[doctorInfo.value.userId] || {};

      // 更新特定患者的标签数据
      doctorPatientTags[props.patientId] = selectedTagList.value;

      // 将更新后的数据重新赋值给 localStorageData
      localStorageData[doctorInfo.value.userId] = doctorPatientTags;

      // 将更新后的 localStorageData 存储到 localStorage
      localStorage.setItem('patientTags', JSON.stringify(localStorageData));
    };

    const load = asyncThrottle(async () => {
      query.value.currentPage += 1;
      getCustomTagGroupList();
    });

    return {
      computedShow,
      customLabelList,
      isMark,
      closeDialog,
      confirm,
      markLabel,
      goTagManage,
      doctorInfo,
      load,
      keyword,
      onKeywordSearch,
      highlightMatch,
      patientTagList,
      onTagClick,
      selectedTagList,
    };
  },
};
